import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ProductListDemo } from '../../../../data';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ApiGetServicesList } from './ServiceOperation';

const ServicesContext = createContext();

export const useServices = () => useContext(ServicesContext);

function ServicesProvider({ children }) {
    const { setMessage } = useTemplate();
    const [reloadKey, setReloadKey] = useState(0);
    const [addServiceModal, setAddServiceModal] = useState(false);
    const [servicesData, setServicesData] = useState(ProductListDemo || {});
    const [services, setServices] = useState(servicesData.applicationList);
    const [servicesFilter, setServicesFilter] = useState({
        searchValue: '',
        status: ''
    });

    useEffect(() => {
        setServicesData(ProductListDemo);
        setServices(ProductListDemo?.applicationList);
        ApiGetServicesList()
            .then(({ data }) => {
                setServicesData(data);
                setServices(data?.serviceList);
            })
            .catch((err) => {
                setServicesData({ serviceList: [] });
                setServices([]);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [reloadKey, setMessage]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        return {
            reloadKey,
            setReloadKey,
            handleReload,
            services,
            setServices,

            // -- Product Data
            servicesData,

            // -- create modal
            addServiceModal,
            setAddServiceModal,

            servicesFilter,
            setServicesFilter
        };
    }, [addServiceModal, servicesData, services, reloadKey, servicesFilter, setServicesFilter]);

    return <ServicesContext.Provider value={value}>{children}</ServicesContext.Provider>;
}

export default ServicesProvider;
